/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    export class JsonDictionaryStoreService {
        constructor() {

        }

        public getJsonStoreDictionary(jsonDictionaryStore:Wars.Domain.Model.JsonDictionaryStore):any {
            return JSON.parse(jsonDictionaryStore.jsonDictionary);
        }

        public containsKey(jsonDictionaryStore:Wars.Domain.Model.JsonDictionaryStore, key: string):boolean {
            let dict = this.getJsonStoreDictionary(jsonDictionaryStore);

            if (!!(dict && dict[key]))
                return true;

            return false;
        }

        public getValue(jsonDictionaryStore:Wars.Domain.Model.JsonDictionaryStore, key: string): any {
            let dict = this.getJsonStoreDictionary(jsonDictionaryStore);

            if (dict) {
                return dict[key];
            }

            return null;
        }
    }
}

warsApp.registerService('JsonDictionaryStoreService',[]);